module.exports = __webpack_public_path__ + "img/bimi-stock-all-rights-reserved@1x.32ab3681.png";